'use client';

import { FC, useEffect } from 'react';
import { QueryContainer } from '@opensearch-project/opensearch/api/_types/_common.query_dsl';

import { buildFacetQueryFilters } from 'opensearch/utils';

import { useOpenSearchContext } from '../hooks';

interface ConfigureProps {
  hitsPerPage?: number;
  restrictSearchableAttributes?: string[];
  filters?: Record<string, Array<string | number | boolean>>;
}
const Configure: FC<ConfigureProps> = ({
  hitsPerPage = 1000,
  restrictSearchableAttributes,
  filters,
}) => {
  const {
    updatePageSize,
    updateSearchableAttributes,
    updateFixedQueryFiltersByFacets,
  } = useOpenSearchContext();

  useEffect(() => {
    updatePageSize(hitsPerPage);
    updateSearchableAttributes(restrictSearchableAttributes);
  }, [hitsPerPage, restrictSearchableAttributes]);

  useEffect(() => {
    updateFixedQueryFiltersByFacets((prev: Record<string, QueryContainer>) => ({
      ...prev,
      ...Object.entries(filters ?? {}).reduce(
        (acc, [attribute, values]) => ({
          ...acc,
          [attribute]: buildFacetQueryFilters(attribute, values),
        }),
        {},
      ),
    }));
  }, [filters]);

  return null;
};

export { Configure };
